import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import DynamicDropdown from "components/Elements/DynamicDropdown";
import { useFilters } from "../FilterContext";
import { useFilterInitialization } from "./hooks/useFilterInitialization";
import { SHOW_ALL_OPTION } from "../constants";

const buildLevelOptions = (maxLevel) => {
	const options = [SHOW_ALL_OPTION];
	for (let i = 2; i <= maxLevel; i++) {
		options.push({ id: i, name: `Level ${i}` });
	}
	return options;
};

export const LevelFilter = () => {
	const { t } = useTranslation();
	const { filterValues, updateFilter, config } = useFilters();
	// maxAssetLevel comes from the API via FilterProvider config — fallback to 8 if not yet loaded
	const maxAssetLevel = config?.filters?.level?.maxAssetLevel || 8;

	const levels = useMemo(
		() => buildLevelOptions(maxAssetLevel),
		[maxAssetLevel]
	);

	useFilterInitialization("level", levels, {
		waitForData: false,
		getDefaultValue: () => SHOW_ALL_OPTION,
		getParams: (item) => ({ level: item.id || "" }),
	});

	if (!filterValues.level) {
		return null;
	}

	const isSiteAssetMode = filterValues.assetGrouping?.value?.id === "siteAsset";

	const handleChange = (item) => {
		updateFilter("level", item, { level: item.id || "" }, true);
	};

	return (
		<Grid item lg={3} md={6} xs={12}>
			<DynamicDropdown
				dataSource={levels}
				columns={[{ name: "name", id: 1 }]}
				showHeader={false}
				width="100%"
				placeholder={t("placeholder.selectLevel")}
				onChange={handleChange}
				selectdValueToshow="name"
				selectedValue={filterValues.level?.value}
				label={t("label.filterByLevel")}
				icon={<FilterListIcon style={{ color: "rgb(48, 122, 215)" }} />}
				required={false}
				showBorderColor
				isReadOnly={isSiteAssetMode}
			/>
		</Grid>
	);
};
